import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=59193e8a&"
import script from "./Translations.vue?vue&type=script&lang=js&"
export * from "./Translations.vue?vue&type=script&lang=js&"
import style0 from "./Translations.vue?vue&type=style&index=0&id=59193e8a&prod&lang=scss&"
import style1 from "./Translations.vue?vue&type=style&index=1&id=59193e8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports